/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Cookiebanner_Accept1Inputs */

const id_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terima`)
};

const ms_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terima`)
};

const da_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptér`)
};

const de_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akzeptieren`)
};

const en_us2_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const es_es2_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar`)
};

const es_mx2_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar`)
};

const fil_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggapin`)
};

const fr_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter`)
};

const it_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accetta`)
};

const hu_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elfogadás`)
};

const nl_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepteren`)
};

const no_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godta`)
};

const pl_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akceptuję`)
};

const pt_br2_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const pt_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceitar`)
};

const ro_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const fi_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyväksy`)
};

const sv_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptera`)
};

const vi_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chấp nhận`)
};

const tr_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabul Et`)
};

const cs_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přijmout`)
};

const bg_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приемам`)
};

const ru_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принять`)
};

const uk_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прийняти`)
};

const ar_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قبول`)
};

const hi_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वीकार करें`)
};

const th_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยอมรับ`)
};

const ja_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同意する`)
};

const zh_cn2_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const zh_hant1_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const ko_components_cookiebanner_accept1 = /** @type {(inputs: Components_Cookiebanner_Accept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

/**
* | output |
* | --- |
* | "Accept" |
*
* @param {Components_Cookiebanner_Accept1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_cookiebanner_accept1 = /** @type {((inputs?: Components_Cookiebanner_Accept1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Cookiebanner_Accept1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_cookiebanner_accept1(inputs)
	if (locale === "ms") return ms_components_cookiebanner_accept1(inputs)
	if (locale === "da") return da_components_cookiebanner_accept1(inputs)
	if (locale === "de") return de_components_cookiebanner_accept1(inputs)
	if (locale === "en-US") return en_us2_components_cookiebanner_accept1(inputs)
	if (locale === "es-ES") return es_es2_components_cookiebanner_accept1(inputs)
	if (locale === "es-MX") return es_mx2_components_cookiebanner_accept1(inputs)
	if (locale === "fil") return fil_components_cookiebanner_accept1(inputs)
	if (locale === "fr") return fr_components_cookiebanner_accept1(inputs)
	if (locale === "it") return it_components_cookiebanner_accept1(inputs)
	if (locale === "hu") return hu_components_cookiebanner_accept1(inputs)
	if (locale === "nl") return nl_components_cookiebanner_accept1(inputs)
	if (locale === "no") return no_components_cookiebanner_accept1(inputs)
	if (locale === "pl") return pl_components_cookiebanner_accept1(inputs)
	if (locale === "pt-BR") return pt_br2_components_cookiebanner_accept1(inputs)
	if (locale === "pt") return pt_components_cookiebanner_accept1(inputs)
	if (locale === "ro") return ro_components_cookiebanner_accept1(inputs)
	if (locale === "fi") return fi_components_cookiebanner_accept1(inputs)
	if (locale === "sv") return sv_components_cookiebanner_accept1(inputs)
	if (locale === "vi") return vi_components_cookiebanner_accept1(inputs)
	if (locale === "tr") return tr_components_cookiebanner_accept1(inputs)
	if (locale === "cs") return cs_components_cookiebanner_accept1(inputs)
	if (locale === "bg") return bg_components_cookiebanner_accept1(inputs)
	if (locale === "ru") return ru_components_cookiebanner_accept1(inputs)
	if (locale === "uk") return uk_components_cookiebanner_accept1(inputs)
	if (locale === "ar") return ar_components_cookiebanner_accept1(inputs)
	if (locale === "hi") return hi_components_cookiebanner_accept1(inputs)
	if (locale === "th") return th_components_cookiebanner_accept1(inputs)
	if (locale === "ja") return ja_components_cookiebanner_accept1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_cookiebanner_accept1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_cookiebanner_accept1(inputs)
	return ko_components_cookiebanner_accept1(inputs)
});
export { components_cookiebanner_accept1 as "components.cookieBanner.accept" }